<template>
  <main class="l-main p-config-user">
    <TitleMain icon="config">
      <span class="title">ユーザー情報・各種設定</span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <div class="l-block l-block--center">
        <TabConfig active="user" />
        <div class="l-block__content">
          <div class="l-block__header">
            <TitleSub level="h3">
              <span class="title">ユーザー情報</span>
            </TitleSub>
          </div>
          <Loading v-if="isLoading" variant="inline" transparent />
          <Alert v-else-if="errorResponse">
            {{ errorResponse }}
          </Alert>
          <template v-else>
            <table class="c-table edit">
              <tbody>
                <tr>
                  <th>
                    お名前
                  </th>
                  <td
                    :class="{
                      alert: isEdited.username && error.username,
                      editLine: isActive.username
                    }"
                  >
                    <div class="l-row l-no-gutters">
                      <div class="l-col">
                        <div class="c-alertPos">
                          <Input
                            name="username"
                            placeholder="例：山田太郎"
                            v-model="params.username"
                            :disabled="!isActive.username"
                            ref="username"
                          />
                          <Alert v-if="isEdited.username && error.username">
                            {{ error.username }}
                          </Alert>
                        </div>
                      </div>
                      <div class="l-col l-col-auto">
                        <Button
                          v-if="isActive.username"
                          variant="main"
                          size="w180"
                          fsize="f14"
                          :class="{ 'is-loading': isProcessing === 'username' }"
                          :disabled="isDisabled.username"
                          @click="updateUserMetaData('username')"
                        >
                          変更確定する
                        </Button>
                        <Button class="edit" @click="toggle('username')">
                          編集する
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>フリガナ</th>
                  <td
                    :class="{
                      alert: isEdited.userkana && error.userkana,
                      editLine: isActive.userkana
                    }"
                  >
                    <div class="l-row l-no-gutters">
                      <div class="l-col">
                        <div class="c-alertPos">
                          <Input
                            name="userkana"
                            placeholder="例：ヤマダタロウ"
                            v-model="params.userkana"
                            :disabled="!isActive.userkana"
                            ref="userkana"
                          />
                          <Alert v-if="isEdited.userkana && error.userkana">
                            {{ error.userkana }}
                          </Alert>
                        </div>
                      </div>
                      <div class="l-col l-col-auto">
                        <Button
                          v-if="isActive.userkana"
                          variant="main"
                          size="w180"
                          fsize="f14"
                          :class="{ 'is-loading': isProcessing === 'userkana' }"
                          :disabled="isDisabled.userkana || !isActive.userkana"
                          @click="updateUserMetaData('userkana')"
                        >
                          変更確定する
                        </Button>
                        <Button class="edit" @click="toggle('userkana')">
                          編集する
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>企業名</th>
                  <td
                    :class="{
                      alert: isEdited.company && error.company,
                      editLine: isActive.company
                    }"
                  >
                    <div class="l-row l-no-gutters">
                      <div class="l-col">
                        <div class="c-alertPos">
                          <Input
                            name="company"
                            placeholder="例：株式会社PLAN-B"
                            v-model="params.company"
                            :disabled="!isActive.company"
                            ref="company"
                          />
                          <Alert v-if="isEdited.company && error.company">
                            {{ error.company }}
                          </Alert>
                        </div>
                      </div>
                      <div class="l-col l-col-auto">
                        <Button
                          v-if="isActive.company"
                          variant="main"
                          size="w180"
                          fsize="f14"
                          :class="{ 'is-loading': isProcessing === 'company' }"
                          :disabled="isDisabled.company"
                          @click="updateUserMetaData('company')"
                        >
                          変更確定する
                        </Button>
                        <Button class="edit" @click="toggle('company')">
                          編集する
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>電話番号</th>
                  <td
                    :class="{
                      alert: isEdited.tel && error.tel,
                      editLine: isActive.tel
                    }"
                  >
                    <div class="l-row l-no-gutters">
                      <div class="l-col">
                        <div class="c-alertPos">
                          <Input
                            name="tel"
                            v-model="params.tel"
                            placeholder="例：000-000-0000"
                            :disabled="!isActive.tel"
                            ref="tel"
                          />
                          <Alert v-if="isEdited.tel && error.tel">
                            {{ error.tel }}
                          </Alert>
                        </div>
                      </div>
                      <div class="l-col l-col-auto">
                        <Button
                          v-if="isActive.tel"
                          variant="main"
                          size="w180"
                          fsize="f14"
                          :class="{ 'is-loading': isProcessing === 'tel' }"
                          :disabled="isDisabled.tel"
                          @click="updateUserMetaData('tel')"
                        >
                          変更確定する
                        </Button>
                        <Button class="edit" @click="toggle('tel')">
                          編集する
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="l-block__header">
              <TitleSub level="h4">
                <span class="title"
                  >メールアドレス、パスワードの変更には再設定が必要です。</span
                >
              </TitleSub>
            </div>
            <div class="c-fieldset">
              <table class="c-table edit">
                <tbody>
                  <tr>
                    <th>メールアドレス</th>
                    <td
                      :class="{
                        alert: isEdited.email && error.email,
                        editLine: isActive.email
                      }"
                    >
                      <div class="l-row l-no-gutters">
                        <div class="l-col">
                          <div class="c-alertPos under">
                            <Input
                              name="newEmail"
                              v-model="params.email"
                              placeholder="例：sample@example.com"
                              ref="email"
                              :disabled="!isActive.email"
                            />
                            <Alert v-if="isEdited.email && error.email">
                              {{ error.email }}
                            </Alert>
                          </div>
                        </div>
                        <div class="l-col l-col-auto">
                          <Button class="edit" @click="toggle('email')">
                            編集する
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Button
                variant="main"
                size="w230"
                fsize="f16"
                :class="{ 'is-loading': isProcessing === 'email' }"
                :disabled="isDisabled.email"
                @click="openEmailModal"
              >
                再設定する
              </Button>
            </div>
            <div class="c-fieldset pass">
              <div class="wrap">
                <p class="c-fieldset__header">
                  <span class="c-fieldset__title">パスワード</span>
                </p>
                <div class="c-fieldset__content c-alertPos">
                  <Input type="password" :value="params.password" disabled />
                </div>
              </div>
              <div class="c-fieldset__btn">
                <Button
                  :to="{
                    name: 'resetPassword',
                    query: { email: data.email }
                  }"
                  variant="main"
                  size="w230"
                  fsize="f16"
                >
                  再設定する
                </Button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <ModalChangeEmail
      v-if="isOpenEmailModal"
      :email="data.email"
      :newEmail="params.email"
      :project="project"
      @close="closeEmailModal"
    />
  </main>
</template>

<script>
import { ERROR_MESSAGE, PASSWORD_MIN_LENGTH } from '@/constants';
import Alert from '@/components/Alert';
import Breadcrumb from '@/components/Breadcrumb';
import Button from '@/components/Button';
import ButtonToProjects from '@/components/ButtonToProjects';
import Input from '@/components/Input';
import Loading from '@/components/Loading';
import ModalChangeEmail from '@/components/config/ModalChangeEmail';
import TabConfig from '@/components/config/TabConfig';
import TitleMain from '@/components/TitleMain';
import TitleSub from '@/components/TitleSub';
import Validation from '@/validation';
import apiUsers from '@/api/users';

export default {
  props: ['project'],
  components: {
    Alert,
    Breadcrumb,
    Button,
    ButtonToProjects,
    Input,
    Loading,
    ModalChangeEmail,
    TabConfig,
    TitleMain,
    TitleSub
  },

  data() {
    return {
      data: {
        company: '',
        email: '',
        tel: '',
        username: '',
        userkana: ''
      },
      error: {
        company: '',
        email: '',
        tel: '',
        userkana: '',
        username: ''
      },
      errorResponse: '',
      params: {
        company: '',
        email: '',
        password: '●'.repeat(PASSWORD_MIN_LENGTH),
        tel: '',
        username: '',
        userkana: ''
      },
      isEdited: {
        company: false,
        email: false,
        tel: false,
        username: false,
        userkana: false
      },
      isLoading: true,
      isOpenEmailModal: false,
      isProcessing: '',
      isActive: {
        username: false,
        userkana: false,
        company: false,
        tel: false,
        email: false
      }
    };
  },

  computed: {
    me() {
      return this.$store.state.user.me;
    },
    isDisabled() {
      let obj = {};
      for (let key in this.params) {
        if (!this.isEdited[key] || this.error[key] || this.isProcessing) {
          obj[key] = true;
        }
      }
      return obj;
    }
  },

  watch: {
    'params.company': {
      handler(value, oldValue) {
        this.error.company = new Validation().input().test(this.params.company);
        this.isEdited.company = this.data.company !== value;
      }
    },
    'params.email': {
      handler(value, oldValue) {
        this.error.email = new Validation()
          .input()
          .email()
          .test(this.params.email);
        this.isEdited.email = this.data.email !== value;
      }
    },
    'params.tel': {
      handler(value, oldValue) {
        this.error.tel = new Validation()
          .input()
          .tel()
          .test(this.params.tel);
        this.isEdited.tel = this.data.tel !== value;
      }
    },
    'params.userkana': {
      handler(value, oldValue) {
        this.error.userkana = new Validation()
          .input()
          .kana()
          .test(this.params.userkana);
        this.isEdited.userkana = this.data.userkana !== value;
      }
    },
    'params.username': {
      handler(value, oldValue) {
        this.error.username = new Validation()
          .input()
          .test(this.params.username);
        this.isEdited.username = this.data.username !== value;
      }
    }
  },

  created() {
    this.auth
      .getUserData()
      .then(response => {
        this.data.company = response.data.user_metadata.company;
        this.data.email = response.data.email;
        this.data.tel = response.data.user_metadata.tel;
        this.data.username = response.data.user_metadata.username;
        this.data.userkana = response.data.user_metadata.userkana;
        this.params.company = response.data.user_metadata.company;
        this.params.email = response.data.email;
        this.params.tel = response.data.user_metadata.tel;
        this.params.username = response.data.user_metadata.username;
        this.params.userkana = response.data.user_metadata.userkana;
        this.isLoading = false;
      })
      .catch(error => {
        this.errorResponse = ERROR_MESSAGE.auth0[error.code]
          ? ERROR_MESSAGE.auth0[error.code]
          : ERROR_MESSAGE.other;
        this.isLoading = false;
      });
  },

  methods: {
    openEmailModal() {
      this.isOpenEmailModal = true;
    },
    closeEmailModal() {
      this.isOpenEmailModal = false;
    },

    updateUserMetaData(key) {
      if (this.isDisabled[key]) return;
      this.isProcessing = key;
      this.isActive[this.isProcessing] = false;

      this.auth
        .getUserData()
        .then(response => {
          let metaData = response.data.user_metadata;
          metaData[key] = this.params[key];
          let data = {
            user_metadata: metaData
          };
          this.auth
            .updateUserData(data)
            .then(response => {
              this.data[key] = this.params[key];
              // ストアに保存しているusernameとcompanyを更新する（代理店アカウントの場合ヘッダーに表示するため）
              this.$store.dispatch('user/setStatus', {
                company: response.data.user_metadata.company,
                username: response.data.user_metadata.username
              });

              if (key === 'username') {
                // DB上の名前を更新する
                this.putUserName(this.params[key]).finally(() => {
                  this.isEdited[key] = false;
                  this.isProcessing = '';
                });
              } else {
                this.isEdited[key] = false;
                this.isProcessing = '';
              }
            })
            .catch(error => {
              this.error[key] = ERROR_MESSAGE.auth0[error.code]
                ? ERROR_MESSAGE.auth0[error.code]
                : ERROR_MESSAGE.other;
              this.isProcessing = '';
            });
        })
        .catch(error => {
          this.error[key] = ERROR_MESSAGE.auth0[error.code]
            ? ERROR_MESSAGE.auth0[error.code]
            : ERROR_MESSAGE.other;
          this.isProcessing = '';
        });
    },
    putUserName(username) {
      const params = {
        name: username
      };
      return apiUsers.name
        .put(params, this.auth.idToken, this.me.userId)
        .then(response => {
          // ストアの情報を更新する
          this.$store.dispatch('user/getMe');
        })
        .catch(error => {});
    },
    toggle(name) {
      this.isActive[name] = !this.isActive[name];
      if (this.isActive[name]) {
        this.$nextTick(() => {
          this.$refs[name].$el.focus();
        });
      } else {
        this.params[name] = this.data[name];
      }
    }
  }
};
</script>
